/**
 * @author kuan
 */

import toAnalysisParams from '@/plugins/toAnalysisParams';

export const ANALYSIS = {
  swap: {category:'material_setting_panel', action:'click_swap', label:'素材设置_设置面板_替换'},
  flip: {category:'material_setting_panel', action:'click_flip_horizontal', label:'素材设置_设置面板_水平翻转'},
  edit: {category:'material_setting_panel', action:'click_edit', label:'素材设置_设置面板_编辑'},
  crop: {category:'material_setting', action:'click_material_setting_crop', label:'素材设置_剪裁'},
  edit_Chart: {category:'material_setting_panel', action:'click_edit', label:'素材设置_设置面板_编辑'},
  motion: {category:'material_setting_panel', action:'click_action', label:'素材设置_选中框_动作'},
  artChange: {category:'material_setting_panel', action:'click_text_effect_change', label:'素材设置面板_文字_效果更改'},
  arrange: {
    front: {category:'material_setting_panel', action:'click_layer_stick', label:'素材设置_设置面板_图层_置顶'},
    back: {category:'material_setting_panel', action:'click_layer_bottom', label:'素材设置_设置面板_图层_置底'},
    forward: {category:'material_setting_panel', action:'click_layer_shift_up', label:'素材设置_设置面板_图层_上移'},
    backward: {category:'material_setting_panel', action:'click_layer_shift_down', label:'素材设置_设置面板_图层_下移'}
  },

  // lottie 循环
  lottieLoopOn: {category:'material_setting_panel', action:'click_open_recycle', label:'素材设置_设置面板_开循环'},
  lottieLoopOff: {category:'material_setting_panel', action:'click_close_recycle', label:'素材设置_设置面板_关循环'},

  // video loop
  videoLoopOn: toAnalysisParams('material_setting_panel,click_video_recycle,素材设置面板_视频_循环'),
  videoLoopOff: toAnalysisParams('material_setting_panel,click_video_cancel_recycle,素材设置面板_视频_取消循环'),

  // soundSprite loop
  soundSpriteOn  : toAnalysisParams('material_setting_panel,click_sound_material_recycle,素材设置面板_视频_循环'),
  soundSpriteOff : toAnalysisParams('material_setting_panel,click_sound_material_cancel_recycle,素材设置面板_视频_取消循环'),
  soundSpriteVolume : toAnalysisParams('material_setting_panel,click_sound_material_volume,素材设置面板_有声素材_音量'),

  // textVertical
  textVertical : toAnalysisParams('material_setting_panel,click_text_vertical,素材设置面板_文字_竖版'),

  pathAnim: {category:'material_setting_panel', action:'click_route_animation', label:'素材设置_设置面板_路径动画'},
  whirl: {category:'material_setting_panel', action:'click_rotate_animation', label:'素材设置_设置面板_旋转动画'},
  shake: {category:'material_setting_panel', action:'click_shake_animation', label:'素材设置_设置面板_抖动动画'},
  gestureIn: {category:'material_setting_panel', action:'click_in_transition_gesture', label:'素材设置_设置面板_手势'},
  gestureOut: {
    category:'material_setting_panel',
    action:'click_out_transition_gesture',
    label:'素材设置_设置面板_手势'
  },
  effects: {
    noAnim: {category:'material_setting_panel', action:'click_in_transition_empty', label:'素材设置_设置面板_入场_无'},
    write: {category:'material_setting_panel', action:'click_in_transition_hand_painting', label:'素材设置_设置面板_入场_手绘'},
    hand: {category:'material_setting_panel', action:'click_in_transition_hand_painting', label:'素材设置_设置面板_入场_手绘'},
    type: {category:'material_setting_panel', action:'click_in_transition_type', label:'素材设置_入场动画_打字机'},
    right: {category:'material_setting_panel', action:'click_in_transition_left', label:'素材设置_设置面板_入场_从左移入'},//'LeftIn',
    left: {category:'material_setting_panel', action:'click_in_transition_right', label:'素材设置_设置面板_入场_从右移入'},//'RightIn',
    up: {category:'material_setting_panel', action:'click_in_transition_down', label:'素材设置_设置面板_入场_从下移入'},
    down: {category:'material_setting_panel', action:'click_in_transition_up', label:'素材设置_设置面板_入场_从上移入'},
    pop: {category:'material_setting_panel', action:'click_in_transition_pop', label:'素材设置_设置面板_入场_放大出现'},
    fade: {category:'material_setting_panel', action:'click_in_transition_fade', label:'素材设置_设置面板_入场_淡入'},
    appear: {category:'material_setting_panel', action:'click_in_transition_appear', label:'素材设置_设置面板_入场_逐行出现'},
    type: {category:'material_setting_panel', action:'click_in_transition_type', label:'素材设置_设置面板_入场_打字机'},
    slide: {category:'material_setting_panel', action:'click_in_transition_move', label:'素材设置_入场动画_移入'},
    smear: {category:'material_setting_panel', action:'click_in_transition_erase', label:'素材设置_入场动画_擦入'},
  },
  outEffects: {
    noAnim: {category:'material_setting_panel', action:'click_out_transition_empty', label:'素材设置_设置面板_出场_无'},
    write: {category:'material_setting_panel', action:'click_out_transition_hand_painting', label:'素材设置_设置面板_出场_手绘'},
    hand: {category:'material_setting_panel', action:'click_out_transition_hand_painting', label:'素材设置_设置面板_出场_手绘'},
    left: {category:'material_setting_panel', action:'click_out_transition_left', label:'素材设置_设置面板_出场_从左移入'},
    right: {category:'material_setting_panel', action:'click_out_transition_right', label:'素材设置_设置面板_出场_从右移入'},
    down: {category:'material_setting_panel', action:'click_out_transition_down', label:'素材设置_设置面板_出场_从下移入'},
    up: {category:'material_setting_panel', action:'click_out_transition_up', label:'素材设置_设置面板_出场_从上移入'},
    pop: {category:'material_setting_panel', action:'click_out_transition_pop', label:'素材设置_设置面板_出场_放大出现'},
    fade: {category:'material_setting_panel', action:'click_out_transition_fade', label:'素材设置_设置面板_出场_淡入'},
    appear: {category:'material_setting_panel', action:'click_out_transition_appear', label:'素材设置_设置面板_出场_逐行出现'},
    slide: {category:'material_setting_panel', action:'click_out_transition_move', label:'素材设置_出场动画_移出'},
    smear: {category:'material_setting_panel', action:'click_in_transition_erase', label:'素材设置_出场动画_擦除'},


  }
};

export default {
  data () {
    return {
      ANALYSIS
    }
  },
  methods: {
    reportAnalysis (key) {
      if (!this.ANALYSIS[key]) {
        return;
      }
      this.$analysis(this.ANALYSIS[key]);
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/mixins/analysis/spriteSettingPopup.js